import PropTypes from 'prop-types';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import ConfirmModal from '../../../ConfirmModal';
import MarkdownToHtml from '../../../MarkdownToHtml';

const CancelFlightInfoModal = ({ onCancel, carrierFullName }) => {
  const { travelAgency } = useSelector((store) => store.user);
  const { tripConfirmation } = useSelector((store) => store.trip);
  const isNdcFare = Boolean(_.get(_.find(tripConfirmation && tripConfirmation.bookingResponses, 'orderId'), 'orderId'));

  const cancelFlight = travelAgency
  && travelAgency.settings && travelAgency.settings.tripConfirmationMessages
  && travelAgency.settings.tripConfirmationMessages.cancelFlight;

  const messages = travelAgency
  && travelAgency.settings && travelAgency.settings.tripConfirmationMessages;
  const ndcMessage = isNdcFare && messages ? messages.cancelNDCFlight : '';

  let message;
  if (!_.isEmpty(ndcMessage) && !_.isEmpty(carrierFullName)) {
    message = <MarkdownToHtml content={ndcMessage.replace('{{airlineName}}', carrierFullName)} className="text-black" />;
  } else {
    message = <MarkdownToHtml content={cancelFlight || `Please contact ${travelAgency.name}'s air desk (see Help menu item at the top of this page) team to cancel flight that's already ticketed.`} className="whitespace-normal break-all md:break-normal" />;
  }
  return (
    <ConfirmModal
      onCancel={onCancel}
      cancelButtonLabel="Close"
      event="Cancel flight booking (not allowed)"
      eventDetail={`Please contact ${travelAgency.name}'s air desk team to cancel flight that's already ticketed.`}
      message={message}
    />
  );
};

CancelFlightInfoModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  carrierFullName: PropTypes.string,
};

CancelFlightInfoModal.defaultProps = {
  carrierFullName: undefined,
};
export default CancelFlightInfoModal;
